import { useState,  useEffect, createRef } from 'react';
import Config from '../Config';

var md5 = require('md5');


function UstawTermin(props)
{

    const [view, setView] = useState('btn');
    const [id, setId] = useState(props.id);
    const [data_prezentacji, setDataPrezentacji] = useState(null);
    const [numer, setNumer] = useState('+48');
    const [nip, setNip] = useState(null);
    const [nazwaPlacowki, setNazwaPlacowki] = useState('');
    const [imie_nazwisko, setImieNazwisko] = useState('');

    const zmienGodzine = (e) => {
        setView("dialog");
    }

    const zamknij = (e) => {
        e.target.innerHTML = "...";        
        setView("btn");
    }


    const zapisz = (e) => {
       
 
 

        if( nip == null ||  nip.length != 10) 
        {           
            setNazwaPlacowki("Podaj prawidłowy NIP");   
            return;
        };
      
        if( !isValidNip(nip) )
        {
          setNazwaPlacowki("Podaj prawidłowy NIP");  
          return;
        }


        if(numer.length < 9) 
        {                       
            return;
        };

        if(imie_nazwisko.length < 9) 
        {                       
            return;
        };


        if(data_prezentacji.length < 5) 
        {                       
            return;
        };




        e.target.innerHTML = "...";

        var dt = {   
            telefon: numer,
            nip: nip,
            firma: nazwaPlacowki,
            termin: data_prezentacji,
            imie_nazwisko: imie_nazwisko
        }
    
        fetch( Config.url + '/rest_public,calendar', {
            method: 'POST', 
            body: JSON.stringify(dt), 
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
         })
         .then(res => res.json() )
         .then(res => {                       
         
                if(res.status == 'OK')
                {
                    alert("Zgłosznie zostało wysłane. Nabawem otrzymasz hasło dostępu do prezentacji VIDEO");
                    zamknij(e);
                }else
                {
                    alert("Aktualnie nie możesz zapisać się na spotkanie. Sprawdź poprawność danych lub spróbuj później.");  
                }
    
         } )
         .catch(err => {
            console.log("Err " + err);
         });
              

    }



    const  onChangeCaptcha = (value) => {
        console.log("Captcha value:", value);
      }

    const changeDataPrezentacji = (e ) => {
        var dt = e.target.value.replace('T',' ');
        setDataPrezentacji(dt);
        console.log(dt);
    }

    const changeNumber = (e) => {
        var dt = e.target.value;
        setNumer(dt);
    }

    const changeImieNazwisko = (e) => {
        var dt = e.target.value;
        setImieNazwisko(dt);
    }


    const changeNip = (e) => {
        var dt = e.target.value;
        dt = dt.replace(/[^0-9.]/g, '');
        setNip(dt);

        checkNip(dt);
    }

    

    const  isValidNip = (nip) => {
        if(typeof nip !== 'string')
            return false;
    
        nip = nip.replace(/[\ \-]/gi, '');
    
        let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;
        let controlNumber = parseInt(nip.substring(9, 10));
        let weightCount = weight.length;
        for (let i = 0; i < weightCount; i++) {
            sum += (parseInt(nip.substr(i, 1)) * weight[i]);
        }
        
        return sum % 11 === controlNumber;
    }


    const checkNip = (nip) => {

      
        if(nip.length > 0) 
        {
            setNazwaPlacowki("Podaj prawidłowy NIP");   
        }

        if(nip.length != 10) 
        {            
            return;
        };
      
        if( !isValidNip(nip) )
        {
         return;
        }


    setNazwaPlacowki("Szukam podmiotu...");     
    
        var token = "7x7";
        token = md5(token);
 

        var dt = {   
            nip: nip,
            token: token,    
        }
    
        fetch( Config.url + '/rest_public,check_nip', {
            method: 'POST', 
            body: JSON.stringify(dt), 
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
         })
         .then(res => res.json() )
         .then(res => {                       
         
                if(res.status == 'OK')
                {
                    setNazwaPlacowki( res.nazwa );
                }else
                {
                    setNazwaPlacowki( "Nie znaleziono");
                }
    
         } )
         .catch(err => {
            console.log("Err " + err);
         });

    }


    if(view == 'btn')
    {
        return <span className='simply_link' onClick={zmienGodzine}>Zapisz się</span>
    }


    var today = new Date();
    var tomorrow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
    var startDate =   tomorrow.toISOString(); // (new Date(tomorrow.getTime() - tomorrow.getTimezoneOffset() * 60000).toISOString()).slice(0, -1);

    var tmp = startDate.split("T");
    startDate = tmp[0] + " 09:00";

    if(data_prezentacji == null)
    {
        setDataPrezentacji(startDate);
    }

 

    return (
        <div className='dialog_termin'>
                <div className='dialog_window'>                       
                        <div className='content'>


                                <fieldset> 
                                   <div className='label'>Imię i nazwisko</div>
                                   <input type="text" value={imie_nazwisko} name="data_prezetnacji" onChange={changeImieNazwisko} required  className='w100proc'  />                        
                                </fieldset>

                                <fieldset> 
                                   <div className='label'>NIP placówki</div>
                                   <input type="text" value={nip} name="data_prezetnacji" onChange={changeNip} required    />
                                   <div className='label'>{nazwaPlacowki}</div>
                                </fieldset>

                                <fieldset>
                                   <div className='label'>Wybierz termin (8:00 - 22:00, pn./nd.)</div>
                                   <input type="datetime-local"   min={startDate}  pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}" required value={data_prezentacji} name="data_prezetnacji" onChange={changeDataPrezentacji} placeholder='RRRR-MM-DD GG:MM'   />
                                </fieldset>

                                <fieldset>
                                   <div className='label'>Numer telefonu (SMS)</div>
                                   <input type="text" value={numer} name="data_prezetnacji" onChange={changeNumber} required placeholder='+48'   />
                                </fieldset> 

                        </div>
                        <div className='buttons'>
                            <span className='simply_link' onClick={zapisz}>Zapisz</span>
                            &nbsp;&nbsp; &nbsp;&nbsp; 
                            &nbsp;&nbsp; &nbsp;&nbsp; 
                            <span className='simply_link' onClick={zamknij}>Anuluj</span>                                                      
                        </div>
                </div>
        </div>
    )
}


export default UstawTermin;